<button
  *ngIf="showScrollToTop"
  matTooltip="Go Up"
  matTooltipPosition="above"
  (click)="backToTop()"
>
  <lss-icon class="up-icon" [svgIcon]="'go-up'"></lss-icon>
</button>
